import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Users, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AcceptTeam() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const { user, loading, refresh } = useAuth();
    const navigate = useNavigate();
    const [state, setState] = useState("idle");

    useEffect(() => {
        if (loading) return;
        if (!user) { navigate(`/login?next=${encodeURIComponent("/entrar-equipe?token=" + token)}`); return; }
        if (!token) { setState("error"); return; }
        (async () => {
            setState("working");
            try { const r = await api.post("/team/accept", { token }); await refresh(); toast.success(`Você agora faz parte da conta ${r.data.account}.`); navigate("/dashboard"); }
            catch (e) { setState("error"); toast.error(e.response?.data?.detail || "Não foi possível aceitar o convite."); }
        })();
    }, [loading, user, token, navigate, refresh]);

    return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
            <div className="w-full max-w-md bg-white border border-slate-200 rounded-lg shadow-sm p-8 text-center" data-testid="accept-team-page">
                <div className="mx-auto w-14 h-14 rounded-full bg-petroleum/10 flex items-center justify-center mb-4"><Users className="w-7 h-7 text-petroleum" /></div>
                <h1 className="font-heading text-2xl font-black text-slate-900">Convite de equipe</h1>
                {state === "working" && <p className="text-slate-500 mt-3 flex items-center justify-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Processando seu convite...</p>}
                {state === "error" && <p className="text-red-600 mt-3 text-sm">Convite inválido, expirado ou destinado a outro e-mail. Verifique com quem enviou.</p>}
            </div>
        </div>
    );
}
